<template>
    <div class="flex items-center bg-gray-100 p-2 rounded-lg w-full max-w-sm" :class="classDiv">
        <!-- Ikon Pencarian -->
        <MagnifyingGlassIcon class="h-5 w-5 text-gray-500 mr-3" />

        <!-- Input Pencarian -->
        <input type="text" :value="modelValue"
            :class="['bg-transparent border-none outline-none text-gray-700 placeholder-gray-500', classAdd]"
            :placeholder="placeholder" 
            @input="$emit('update:modelValue', $event.target.value)"/>
    </div>
</template>

<script>
import { MagnifyingGlassIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'SearchBox',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: 'Cari sesuatu...'
        },
        classAdd: {
            type: String,
            default: ''
        },
        classDiv: {
            type: String,
            default: ''
        }
    },
    components:{
        MagnifyingGlassIcon
    },
    emits: ['update:modelValue'],
};
</script>